import React, { useState, useMemo } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { 
  Users, 
  Search, 
  Calendar, 
  MapPin, 
  Globe2, 
  Award, 
  Copy, 
  Check, 
  BookOpen,
  Filter
} from 'lucide-react';

const conferencesData = [
  {
    id: 1,
    authors: "Meena, A., Dhir, S., & Sushil, S.",
    year: "2022",
    title: "Coopetition: A Critical Review and Directions for Future Research",
    conference: "IEEE ICE – IAMOT Conference 2022",
    location: "International",
    tag: "Coopetition & Strategy"
  },
  {
    id: 2,
    authors: "Meena, A., Dhir, S., & Sushil, S.",
    year: "2022",
    title: "Triangulation and Multiple Case Study Approach in Understanding Coopetition",
    conference: "International Marketing Conference",
    location: "IIM Shillong, India",
    tag: "Methodology & Case Research"
  },
  {
    id: 3,
    authors: "Singh, S., Singh, S., & Dhir, S.",
    year: "2022",
    title: "The Evolving Relationship of Entrepreneurship, Technology, and Innovation: A Topic Modelling Perspective",
    conference: "ICE-IAMOT 2022 Conference",
    location: "International",
    tag: "Topic Modelling & Tech"
  },
  {
    id: 4,
    authors: "Singh, S., Chikhale, M. M., & Dhir, S.",
    year: "2022",
    title: "Innovation Management in Firms: A Review and Research Agenda",
    conference: "ICE-IAMOT 2022 Conference",
    location: "International",
    tag: "Innovation Management"
  },
  {
    id: 5,
    authors: "Rajan, R., Dhir, S., & Sushil",
    year: "2022",
    title: "A Study on the Influence of Factors Associated with Technology Management and SDGs: An M-TISM Approach",
    conference: "GLOGIFT 21 Conference",
    location: "April 2022",
    tag: "TISM & Sustainability"
  },
  {
    id: 6,
    authors: "Sharma, K., Dhir, S., & Ongsakul, V.",
    year: "2022",
    title: "Artificial intelligence and hospitality industry: systematic review using TCCM",
    conference: "AGBA 2022 Global Conference",
    location: "Global",
    tag: "AI in Hospitality"
  },
  {
    id: 7,
    authors: "Singh, S., Singh, S., & Dhir, S.",
    year: "2022",
    title: "Topic Modelling Perspective – Entrepreneurship, Technology, Innovation",
    conference: "AGBA 2022 Conference",
    location: "Global",
    tag: "Topic Modelling & Tech"
  },
  {
    id: 8,
    authors: "Lamba, H. K. & Dhir, S.",
    year: "2022",
    title: "Strategic Motives for Formation of Alliances: A Multi-Method Approach",
    conference: "AGBA 2022",
    location: "Istanbul, Turkey",
    tag: "Strategic Alliances"
  },
  {
    id: 9,
    authors: "Lamba, H. K. & Dhir, S.",
    year: "2022",
    title: "The Role of Meta-Organisation in Environmental Sustainability for Emerging Markets",
    conference: "GLOGIFT 2022",
    location: "IIM Shillong, India",
    tag: "Sustainability"
  },
  {
    id: 10,
    authors: "Sharma, K., Jain, M., & Dhir, S.",
    year: "2021",
    title: "Analysing the impact of artificial intelligence on competitiveness of tourism firms: M-TISM approach",
    conference: "IAMOT 2021",
    location: "Cairo, Egypt",
    tag: "AI & Competitiveness"
  },
  {
    id: 11,
    authors: "Sharma, K., Jain, M., & Dhir, S.",
    year: "2021",
    title: "Impact of artificial intelligence on the competitiveness of a tourism firm",
    conference: "International Conference of the International Association for Management of Technology 2021",
    location: "Cairo, Egypt",
    tag: "AI & Competitiveness"
  },
  {
    id: 12,
    authors: "Singh, S., Sharma, M., & Dhir, S.",
    year: "2021",
    title: "Antecedents and Mediating Role of Digital Transformation in Improving Firm Performance",
    conference: "International Conference of IAMOT 2021",
    location: "Cairo, Egypt",
    tag: "Digital Transformation"
  },
  {
    id: 13,
    authors: "Lamba, H. K. & Dhir, S.",
    year: "2021",
    title: "Strategic Motives for Formation of Alliances: Review and Future Research Agenda",
    conference: "International Conference of IAMOT 2021",
    location: "Cairo, Egypt",
    tag: "Strategic Alliances"
  },
  {
    id: 14,
    authors: "Shaik, A. S., & Dhir, S.",
    year: "2021",
    title: "What Drives Organisational Performance: Strategic Thinking, Technological Change, Strategic Risks? A Modified Total Interpretive Structural Modelling Approach and MICMAC Analysis",
    conference: "International Conference of IAMOT 2021",
    location: "Cairo, Egypt",
    tag: "Strategic Thinking & TISM"
  },
  {
    id: 15,
    authors: "Rajan, R., Dhir, S., & Sushil",
    year: "2020",
    title: "Determinants of Alliance Productivity and Performance: A Modified Total Interpretive Structural Modeling",
    conference: "British Academy of Management Conference 2020",
    location: "Manchester, United Kingdom",
    tag: "Strategic Alliances"
  },
  {
    id: 16,
    authors: "Meena, A., & Dhir, S.",
    year: "2020",
    title: "Coopetition Strategy: A Review and Future Research Agenda",
    conference: "AIB INDIA Conference 2020",
    location: "IIM Visakhapatnam, India",
    tag: "Coopetition & Strategy"
  },
  {
    id: 17,
    authors: "Rajan, R., Dhir, S., & Sushil",
    year: "2019",
    title: "Critical Success Factors for New Product Development and Innovation to Support Make in India Program",
    conference: "IIT Delhi Industry Day 2019",
    location: "IIT Delhi, India",
    tag: "Innovation Management"
  },
  {
    id: 18,
    authors: "Rajan, R., Dhir, S., & Sushil",
    year: "2019",
    title: "Strategic Technology Management for Sustainable Development through Innovation: A Modified TISM Approach",
    conference: "Academy for Global Business Advancement Conference 2019",
    location: "Global",
    tag: "TISM & Sustainability"
  },
  {
    id: 19,
    authors: "Singh, S., Dhir, S., Das, V.M., & Sharma, A.",
    year: "2019",
    title: "The Evolution and Intellectual Structure of the Technological Forecasting and Social Change Journal: A Bibliometric Analysis from 1970 to 2019",
    conference: "Academy of Global Business Advancement's 16th World Congress 2019",
    location: "India",
    tag: "Bibliometrics"
  },
  {
    id: 20,
    authors: "Lamba, H. K. & Dhir, S.",
    year: "2019",
    title: "Analysis of Motives for Alliance Formation Using Total Interpretive Structural Modelling",
    conference: "British Academy of Management Conference Proceedings (Vol. 2019, No. 1)",
    location: "London, United Kingdom",
    tag: "Strategic Alliances"
  },
  {
    id: 21,
    authors: "Lamba, H. K. & Dhir, S.",
    year: "2019",
    title: "Analysis of Motives for Alliance Formation Using Total Interpretive Structural Modelling",
    conference: "British Academy of Management",
    location: "Birmingham, United Kingdom",
    tag: "Strategic Alliances"
  },
  {
    id: 22,
    authors: "Batra, I., & Dhir, S.",
    year: "2019",
    title: "Effect of Ambidexterity on the Performance of International Joint ventures: In an Emerging Market Context",
    conference: "Academy of Global Business Advancement Conference",
    location: "IIT Delhi, India",
    tag: "Ambidexterity & Joint Ventures"
  },
  {
    id: 23,
    authors: "Batra, I., Preethi, P., & Dhir, S.",
    year: "2019",
    title: "Meta-Action Research on Antecedents of ambidexterity",
    conference: "Academy of Global Business Advancement Conference",
    location: "IIT Delhi, India",
    tag: "Ambidexterity & Joint Ventures"
  },
  {
    id: 24,
    authors: "Shaik, A. S., & Dhir, S.",
    year: "2019",
    title: "A meta-analytical review of factors affecting the strategic thinking of an organization",
    conference: "British Academy of Management",
    location: "Birmingham, United Kingdom",
    tag: "Strategic Thinking & TISM"
  },
  {
    id: 25,
    authors: "Rajan, R., Parameswar, N., & Dhir, S.",
    year: "2018",
    title: "Incorporating Polarity of Relationships in TISM for Organizational Information and Cyber Security Management",
    conference: "18th GLOGIFT Conference",
    location: "IIM Lucknow, India",
    tag: "TISM & Sustainability"
  },
  {
    id: 26,
    authors: "Singh, S., Dhir, S., Das, V.M., & Sharma, A.",
    year: "2018",
    title: "The Role of Institutions in Fostering Entrepreneurial Ecosystem: A Modified Total Interpretive Structure Modelling Approach",
    conference: "18th GLOGIFT Conference",
    location: "IIM Lucknow, India",
    tag: "TISM & Sustainability"
  },
  {
    id: 27,
    authors: "Singh, S., Dhir, S., Das, V.M., & Sharma, A.",
    year: "2018",
    title: "Measuring Innovation Management from Firms' Perspective: A Review",
    conference: "PAN IIT International Management Conference",
    location: "IIT Roorkee, India",
    tag: "Innovation Management"
  },
  {
    id: 28,
    authors: "Singh, S., & Dhir, S.",
    year: "2018",
    title: "Institutional Enablers of National Innovation System: A Total Interpretive Structure Modelling Approach",
    conference: "AGBA 15th World Congress 2018",
    location: "NIDA Business School, Bangkok, Thailand",
    tag: "TISM & Sustainability"
  },
  {
    id: 29,
    authors: "Shaik, A. S., & Dhir, S.",
    year: "2018",
    title: "Strategic Thinking of CEOs on Strategy Framing and its Impact on the Firm Performance: A System Dynamics Approach",
    conference: "Academy for Global Business Advancement",
    location: "Bangkok, Thailand",
    tag: "Strategic Thinking & TISM"
  },
  {
    id: 30,
    authors: "Lamba, H.K. & Dhir, S.",
    year: "2018",
    title: "Analysis of Strategic Motives for Alliance Formation using TISM",
    conference: "18th GLOGIFT Conference",
    location: "IIM Lucknow, India",
    tag: "Strategic Alliances"
  },
  {
    id: 31,
    authors: "Batra, I., Gupta, M., & Dhir, S.",
    year: "2018",
    title: "Impact of Structural Factors on the Performance of IJVs: A Meta-Analysis",
    conference: "18th GLOGIFT conference",
    location: "IIM Lucknow, India",
    tag: "Ambidexterity & Joint Ventures"
  },
  {
    id: 32,
    authors: "Batra, I., & Dhir, S.",
    year: "2018",
    title: "Antecedents of Performance of International Joint Ventures: A Meta-Analysis Review",
    conference: "Academy of Global Business Advancement Conference",
    location: "Thailand",
    tag: "Ambidexterity & Joint Ventures"
  },
  {
    id: 33,
    authors: "Batra, I., & Dhir, S.",
    year: "2018",
    title: "The Impact of Psychic Distance and Interpartner Fit on International Joint Ventures Performance",
    conference: "Academy of International Business (AIB) India Chapter Conference",
    location: "Shimla, India",
    tag: "Ambidexterity & Joint Ventures"
  },
  {
    id: 34,
    authors: "Abhilasha, M., Dhir, S., & Sushil, S.",
    year: "2018",
    title: "An analysis of growth accelerating factors using TISM",
    conference: "18th Global Conference on Flexible Systems Management",
    location: "IIM Lucknow, India",
    tag: "TISM & Sustainability"
  },
  {
    id: 35,
    authors: "Smriti, V., Dhir, S., & Dhir, S.",
    year: "2018",
    title: "Strategic thinking in professional environment: a review of the literature",
    conference: "Academy of Management Proceedings (Vol. 2018, No. 1, p. 13991)",
    location: "Briarcliff Manor, NY, USA",
    tag: "Strategic Thinking & TISM"
  },
  {
    id: 36,
    authors: "Dhir, S., Dhir, S., & Smriti, V.",
    year: "2018",
    title: "Strategic Thinking in Professional Environment: A Review of the Literature",
    conference: "Academy of Management Annual Meeting",
    location: "Chicago, Illinois, USA",
    tag: "Strategic Thinking & TISM"
  },
  {
    id: 37,
    authors: "Batra, I. & Dhir, S.",
    year: "2018",
    title: "The Impact of Psychic Distance and Interpartner Fit on International Joint Ventures Performance: In the Context of New Normal Global Business Landscape",
    conference: "Academy of International Business (AIB) India Chapter Conference",
    location: "Shimla, India",
    tag: "Ambidexterity & Joint Ventures"
  },
  {
    id: 38,
    authors: "Dhir, S. & Sushil",
    year: "2017",
    title: "Impact of Decentralization on the reputation of the National Public Procurement Agency",
    conference: "Seventeenth Global Conference on Flexible Systems Management",
    location: "IIT Delhi, India",
    tag: "Flexibility & Governance"
  },
  {
    id: 39,
    authors: "Parameswar, N., Dhir, S., & Dhir, S.",
    year: "2017",
    title: "Global Marketplace Strategy and Choice of Interaction Post International Joint Venture Termination",
    conference: "Academy of International Business (AIB) US Southeast Conference",
    location: "Washington, DC, USA",
    tag: "Ambidexterity & Joint Ventures"
  },
  {
    id: 40,
    authors: "Parameswar, N., Singh, A., Malik, R., & Dhir, S.",
    year: "2016",
    title: "efin Recruiters: at the crossroads of the Indian Recruitment Process Outsourcing Industry - A Case Study",
    conference: "The International Conference on Business Case Research",
    location: "Hong Kong",
    tag: "Methodology & Case Research"
  },
  {
    id: 41,
    authors: "Parameswar, N. & Dhir, S.",
    year: "2017",
    title: "Factors Influencing Choice of Interaction Post International Joint Venture Termination: An Emerging Market Perspective",
    conference: "Strategic Management Society Special Conference",
    location: "Hong Kong",
    tag: "Ambidexterity & Joint Ventures"
  },
  {
    id: 42,
    authors: "Parameswar, N. & Dhir, S.",
    year: "2016",
    title: "Technology Transfer and Innovation in Global International Joint Venture (IJV) - Emerging Markets Perspective",
    conference: "Sixteenth Global Conference on Flexible Systems Management",
    location: "International",
    tag: "Ambidexterity & Joint Ventures"
  },
  {
    id: 43,
    authors: "Chanu, O. R., & Dhir, S.",
    year: "2016",
    title: "A Perspective of Strategic Flexibility in a Joint Venture Healthcare Firms for Innovative Products",
    conference: "Sixteenth Global Conference on Flexible Systems Management",
    location: "International",
    tag: "Flexibility & Governance"
  },
  {
    id: 44,
    authors: "Nisha & Dhir, S.",
    year: "2016",
    title: "Inter Partner Dynamics and Joint Venture Competitiveness: A TISM Approach",
    conference: "Sixteenth Global Conference on Flexible Systems Management",
    location: "University of Technology, Sydney, Australia",
    tag: "TISM & Sustainability"
  },
  {
    id: 45,
    authors: "Shrotriya, S., & Dhir, S.",
    year: "2016",
    title: "Strengthening Indian MSME Clusters for the GVC Challenges – A TRIZ Based Problem Solving Analysis",
    conference: "Sixteenth Global Conference on Flexible Systems Management",
    location: "International",
    tag: "Flexibility & Governance"
  },
  {
    id: 46,
    authors: "Dhir, S., & Dhir, S.",
    year: "2015",
    title: "Cross Cultural Management in International Businesses",
    conference: "Indian Academy of Management",
    location: "IIM Lucknow, India",
    tag: "Flexibility & Governance"
  },
  {
    id: 47,
    authors: "Dhir, S. & Sushil",
    year: "2016",
    title: "Strategic Flexibility and Termination of International Joint Ventures (IJVs)",
    conference: "Sixteenth Global Conference on Flexible Systems Management",
    location: "University of Technology, Sydney, Australia",
    tag: "Flexibility & Governance"
  },
  {
    id: 48,
    authors: "Dhir, S., & Dhir, S.",
    year: "2015",
    title: "Technology Penetration and its Impact on Information Access by Customers: An Exploratory Study",
    conference: "12th Annual World Congress of the Academy for Global Business Advancement",
    location: "Global",
    tag: "Topic Modelling & Tech"
  },
  {
    id: 49,
    authors: "Dhir, S., & Dhir, S.",
    year: "2015",
    title: "HR Capability and Strategic Drivers of Firm Performance",
    conference: "Fifteenth International Global Conference on Flexible Systems Management",
    location: "International",
    tag: "Flexibility & Governance"
  },
  {
    id: 50,
    authors: "Nisha & Dhir, S.",
    year: "2015",
    title: "Strategic Flexibility: A Literature Review",
    conference: "15th Global Conference on Flexible Systems Management",
    location: "International",
    tag: "Flexibility & Governance"
  },
  {
    id: 51,
    authors: "Dhir, S.",
    year: "2014",
    title: "Banking on Innovation: Technological Innovations at ICICI Bank",
    conference: "AGBA Conference",
    location: "Global",
    tag: "Innovation Management"
  },
  {
    id: 52,
    authors: "Dhir, S. & Sushil",
    year: "2014",
    title: "Global Competitiveness of the Informal Economy Organizations",
    conference: "7th International Conference on Contemporary Business 2014 & 14th Global Conference on Flexible Systems Management",
    location: "International",
    tag: "Flexibility & Governance"
  },
  {
    id: 53,
    authors: "Dhir, S., & Mital, A.",
    year: "2013",
    title: "Value Creation on Bilateral Cross-Border Joint Ventures (CBJV): Evidence from India",
    conference: "Academy of Management Proceedings (Vol. 2013, No. 1, pp. 13564)",
    location: "Briarcliff Manor, NY, USA",
    tag: "Ambidexterity & Joint Ventures"
  },
  {
    id: 54,
    authors: "Dhir, S.",
    year: "2013",
    title: "Dynamics in Indian Bilateral Cross-Border Joint Ventures: Exploration through System Dynamics",
    conference: "Strategic Management Society Annual Conference",
    location: "Glasgow, Scotland",
    tag: "Ambidexterity & Joint Ventures"
  },
  {
    id: 55,
    authors: "Dhir, S.",
    year: "2012",
    title: "Dynamics of Value Creation in Indian Bilateral Cross-Border Joint Ventures: A Systems Approach",
    conference: "ISCI",
    location: "IIT Bombay, India",
    tag: "Ambidexterity & Joint Ventures"
  },
  {
    id: 56,
    authors: "Dhir, S.",
    year: "2012",
    title: "Network Heterogeneity, Absorptive Capacity and Innovation Performance: A Study of Mediation and Moderation Effects",
    conference: "Strategic Management Society",
    location: "Singapore",
    tag: "Strategic Alliances"
  },
  {
    id: 57,
    authors: "Dhir, S.",
    year: "2012",
    title: "Asymmetric Motives in Indian Bilateral Cross-Border Joint Ventures (CBJVs) with G7 Nations: Impact of Relative Partner Characteristics and Initial CBJV Conditions",
    conference: "Southern Management Association Conference Proceedings",
    location: "Florida, USA",
    tag: "Ambidexterity & Joint Ventures"
  },
  {
    id: 58,
    authors: "Dhir, S., & Mital, A.",
    year: "2012",
    title: "Network Heterogeneity and Alliance Performance: An Empirical Analysis",
    conference: "Conference on Excellence in Research & Education",
    location: "IIM Indore, India",
    tag: "Strategic Alliances"
  },
  {
    id: 59,
    authors: "Dhir, S.",
    year: "2010",
    title: "Dynamics of Strategic Alliances: A Conceptual Review",
    conference: "13th Annual Convention, Strategic Management Forum",
    location: "Noida, India",
    tag: "Strategic Alliances"
  }
];

const tags = [
  "All",
  "Strategic Alliances",
  "Ambidexterity & Joint Ventures",
  "TISM & Sustainability",
  "Strategic Thinking & TISM",
  "Flexibility & Governance",
  "Innovation Management"
];

export default function Conferences() {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedTag, setSelectedTag] = useState("All");
  const [copiedId, setCopiedId] = useState(null);

  const filteredConferences = useMemo(() => {
    return conferencesData.filter((item) => {
      const matchesTag = selectedTag === "All" || item.tag === selectedTag;
      const q = searchTerm.toLowerCase();
      const matchesSearch =
        item.title.toLowerCase().includes(q) ||
        item.authors.toLowerCase().includes(q) ||
        item.conference.toLowerCase().includes(q) ||
        item.location.toLowerCase().includes(q) ||
        item.year.includes(q);

      return matchesTag && matchesSearch;
    });
  }, [searchTerm, selectedTag]);

  const handleCopyCitation = (item) => {
    const text = `${item.authors} (${item.year}). ${item.title}. In ${item.conference}${item.location ? `, ${item.location}` : ''}.`;
    navigator.clipboard.writeText(text);
    setCopiedId(item.id);
    setTimeout(() => setCopiedId(null), 2000);
  };

  return (
    <div className="container py-5 min-vh-100 position-relative text-light" style={{ zIndex: 1 }}>
      
      {/* 1. Header Banner */}
      <div className="row align-items-center g-4 mb-5">
        <div className="col-12 col-lg-8" data-aos="fade-right">
          <div className="d-inline-flex align-items-center gap-2 px-3 py-1 rounded-pill mb-3 sub-badge">
            <Users size={16} className="text-cyan" />
            <span className="small text-light fw-medium">Global Conference Proceedings & Symposia</span>
          </div>

          <h1 className="display-5 fw-bold text-white mb-3">
            Academic <span className="text-gradient">Conferences</span>
          </h1>

          <p className="lead text-secondary fs-6 mb-4 pe-lg-3">
            Peer-reviewed papers and research presentations presented across globally renowned conferences including the 
            <strong> Academy of Management (AoM)</strong>, <strong>Strategic Management Society (SMS)</strong>, 
            <strong> British Academy of Management (BAM)</strong>, and <strong>Academy of International Business (AIB)</strong>[cite: 2].
          </p>

          {/* Quick Metrics Bar */}
          <div className="d-flex flex-wrap gap-3">
            <div className="p-3 rounded-3 glass-card-sm text-center" style={{ minWidth: '110px' }}>
              <span className="fs-4 fw-bold text-cyan">59+</span>
              <span className="small text-secondary d-block" style={{ fontSize: '0.75rem' }}>Conference Papers</span>
            </div>
            <div className="p-3 rounded-3 glass-card-sm text-center" style={{ minWidth: '110px' }}>
              <span className="fs-4 fw-bold text-warning">AoM & SMS</span>
              <span className="small text-secondary d-block" style={{ fontSize: '0.75rem' }}>Premier Platforms</span>
            </div>
            <div className="p-3 rounded-3 glass-card-sm text-center" style={{ minWidth: '110px' }}>
              <span className="fs-4 fw-bold text-info">2010 – 2022</span>
              <span className="small text-secondary d-block" style={{ fontSize: '0.75rem' }}>Active Timeline</span>
            </div>
          </div>
        </div>

        {/* Global Symposia Card */}
        <div className="col-12 col-lg-4" data-aos="fade-left">
          <div className="p-4 rounded-4 glass-panel border-glow text-center d-flex flex-column align-items-center justify-content-center h-100">
            <Globe2 size={42} className="text-cyan mb-3" />
            <h5 className="text-white fw-bold mb-2">Global Research Reach</h5>
            <p className="text-secondary small mb-0 lh-base">
              Disseminating empirical evidence across emerging markets, strategic flexibility, joint venture dynamics, and digital ambidexterity[cite: 2].
            </p>
          </div>
        </div>
      </div>

      {/* 2. Search & Tag Filters */}
      <div className="p-4 rounded-4 glass-panel mb-5" data-aos="fade-up">
        <div className="row g-3 align-items-center justify-content-between">
          
          {/* Search Box */}
          <div className="col-12 col-md-5">
            <div className="position-relative">
              <Search size={18} className="text-secondary position-absolute top-50 start-0 translate-middle-y ms-3" />
              <input
                type="text"
                placeholder="Search by title, author, conference, or year..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="form-control rounded-pill ps-5 bg-dark text-light border border-secondary border-opacity-50 py-2 small"
              />
            </div>
          </div>

          {/* Result Count */}
          <div className="col-12 col-md-auto text-md-end text-secondary small">
            Showing <strong className="text-white">{filteredConferences.length}</strong> of {conferencesData.length} conference presentations
          </div>
        </div>

        {/* Domain Filter Badges */}
        <div className="d-flex flex-wrap gap-2 mt-3 pt-3 border-top border-secondary border-opacity-25 align-items-center">
          <div className="d-flex align-items-center gap-1 text-secondary small me-2">
            <Filter size={14} /> Topic:
          </div>
          {tags.map((tag, idx) => {
            const isSelected = selectedTag === tag;
            return (
              <button
                key={idx}
                type="button"
                onClick={() => setSelectedTag(tag)}
                className="btn btn-sm rounded-pill px-3 py-1 transition-all"
                style={{
                  fontSize: '0.8rem',
                  fontWeight: isSelected ? '700' : '500',
                  color: isSelected ? '#0a0f1d' : '#94a3b8',
                  background: isSelected ? 'linear-gradient(135deg, #00f2fe, #4facfe)' : 'rgba(255, 255, 255, 0.05)',
                  border: isSelected ? '1px solid #00f2fe' : '1px solid rgba(255, 255, 255, 0.15)',
                  boxShadow: isSelected ? '0 0 14px rgba(0, 242, 254, 0.45)' : 'none'
                }}
              >
                {tag}
              </button>
            );
          })}
        </div>
      </div>

      {/* 3. Conference Cards Grid */}
      <div className="row g-4">
        <AnimatePresence>
          {filteredConferences.map((item, index) => (
            <motion.div
              layout
              initial={{ opacity: 0, y: 15 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, scale: 0.95 }}
              transition={{ duration: 0.25 }}
              key={`${item.id}-${index}`}
              className="col-12 col-lg-6"
            >
              <div 
                className="p-4 rounded-4 glass-panel h-100 d-flex flex-column justify-content-between position-relative overflow-hidden"
                style={{
                  borderLeft: item.year === "2022" 
                    ? '4px solid #00f2fe' 
                    : '4px solid rgba(255, 255, 255, 0.15)'
                }}
              >
                <div>
                  {/* Category & Year Header */}
                  <div className="d-flex justify-content-between align-items-center gap-2 mb-2">
                    <span 
                      className="badge px-3 py-1 rounded-pill small"
                      style={{
                        background: 'rgba(0, 242, 254, 0.08)',
                        color: '#00f2fe',
                        border: '1px solid rgba(0, 242, 254, 0.2)',
                        fontSize: '0.72rem'
                      }}
                    >
                      {item.tag}
                    </span>

                    <span className="small text-warning fw-semibold d-inline-flex align-items-center gap-1">
                      <Calendar size={13} /> {item.year}
                    </span>
                  </div>

                  {/* Title */}
                  <h5 className="text-white fw-bold fs-6 mb-2 lh-base">
                    {item.title}
                  </h5>

                  {/* Authors */}
                  <p className="text-light opacity-90 small mb-2">
                    {item.authors}
                  </p>

                  {/* Conference Venue */}
                  <p className="text-info small mb-3">
                    <strong>Conference:</strong> {item.conference}
                  </p>
                </div>

                {/* Footer Location & Citation Copy */}
                <div className="pt-3 border-top border-secondary border-opacity-15 d-flex align-items-center justify-content-between gap-2 text-secondary small">
                  <div className="d-inline-flex align-items-center gap-1 text-truncate">
                    <MapPin size={14} className="text-cyan flex-shrink-0" />
                    <span className="text-truncate">{item.location}</span>
                  </div>

                  <button
                    type="button"
                    onClick={() => handleCopyCitation(item)}
                    className="btn btn-sm btn-outline-glass text-secondary d-inline-flex align-items-center gap-1 px-2 py-1 rounded-pill"
                    style={{ fontSize: '0.72rem' }}
                    title="Copy APA Citation"
                  >
                    {copiedId === item.id ? (
                      <>
                        <Check size={12} className="text-success" />
                        <span className="text-success fw-bold">Copied</span>
                      </>
                    ) : (
                      <>
                        <Copy size={12} />
                        <span>Cite</span>
                      </>
                    )}
                  </button>
                </div>
              </div>
            </motion.div>
          ))}
        </AnimatePresence>

        {filteredConferences.length === 0 && (
          <div className="col-12 text-center py-5">
            <p className="text-secondary fs-5 mb-0">No conference papers match your search criteria.</p>
          </div>
        )}
      </div>

    </div>
  );
}